<template>
  <div>
    <!-- Incident settings block -->
    <div class="card">
      <div class="card-body" id="update_description" :class="{'pr-0 pl-0': showOnTask}">
        <div class="mb-2">
          <h5 class="h5" v-if="!showOnTask">
            {{ $t('maintenance.incidents.incident_categories.settings.title') }}
          </h5>
          <span v-if="!showOnTask">
            <span class="cursor-pointer task-label-open mr-2 ml-2 mr-2"
                  v-if="getTask('update_description')"
            >
              <UpdateSingleTaskModal
                  :task="myTasks[0]"
                  @reloadContent="reloadContent"
                  :editIcon="true"
                  name="123"
              ></UpdateSingleTaskModal>
            </span>
            <span v-if="getGuide('update_settings')">
              <GuideButton :guide="getGuide('update_settings')"></GuideButton>
            </span>
          </span>
        </div>

        <div class="mt-3">
          <div class="float-right btn-sm btn-edit mr-0"
               @click="showFormFunction"
               qid="processing-role-edit-button"
               v-if="!showForm && isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
          >
            <font-awesome-icon icon="pen"/>
          </div>
          <label>
            {{ $t('maintenance.incidents.incident_categories.settings.anonymous_title') }}
          </label>
        </div>
        <div class="mw-600" v-if="showForm">
          <multiselect
              v-model="selectedAnonymous"
              :options="radioOptions"
              :placeholder="$t('maintenance.incidents.incident_categories.settings.anonymous_title')"
              label="text"
              :select-label="$t('system.dropdown_select_label')"
              :selected-label="$t('system.dropdown_selected_label')"
              :deselect-label="$t('system.dropdown_deselect_label')"
              track-by="value"
              :allow-empty="false"
              class="mw-600"
              qid="processing-role-dropdown"
          ></multiselect>
          <div class="mt-3" v-if="selectedAnonymous.value == 1">
            <label>
              {{ $t('maintenance.incidents.incident_categories.settings.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-p-form-description"
              v-model="anonymousDescription"
              rows="6"
              :placeholder="$t('maintenance.third_parties.create.description_placeholder')"
            ></b-form-textarea>
          </div>
          <div class="text-left mt-3">
            <b-button class=""
                      variant="secondary"
                      @click="cancelForm"
                      qid="edit-pr-cancel-button"
            >
              {{ $t('activities.processing_type.cancel') }}
            </b-button>
            <b-button class="ml-2"
                      variant="success"
                      @click="formSubmit"
                      qid="edit-pr-submit-button"
            >
              {{ $t('activities.processing_type.submit') }}
            </b-button>
          </div>
        </div>
        <div v-if="!showForm">
          <div v-if="incident" class="mt-2 section-container text-normal">
            <span v-if="incident.anonymous == 1">
              <font-awesome-icon icon="check-circle" class="icon-success"/>
              {{ $t('system.yes') }}
            </span>
            <span v-if="!incident.anonymous">
              <font-awesome-icon icon="times-circle" class="icon-danger"/>
              {{ $t('system.no') }}
            </span>
          </div>

          <div class="mt-3" v-if="incident.anonymous == 1">
            <label>
              {{ $t('maintenance.incidents.incident_categories.settings.description_label') }}
            </label>

            <div class="section-container text-normal">
              <div v-if="incident.anonymous_description && incident.anonymous_description.length > descriptionLength">
                <p v-if="showFullDescription" class="text-formatted">{{ incident.anonymous_description }}</p>
                <p v-if="!showFullDescription" class="text-formatted">{{ incident.anonymous_description | truncate(descriptionLength) }}</p>
                <div class="text-center mt-3" @click="showFullDescription=!showFullDescription">
                  <span class="cursor-pointer" v-if="!showFullDescription">
                    <span class="mr-2">
                      {{ $t('system.view_more') }}
                    </span>
                    <font-awesome-icon icon="chevron-down"/>
                  </span>
                  <span class="cursor-pointer" v-if="showFullDescription">
                    <span class="mr-2">
                      {{ $t('system.view_less') }}
                    </span>
                    <font-awesome-icon icon="chevron-up"/>
                  </span>
                </div>
              </div>
              <p v-if="incident.anonymous_description && incident.anonymous_description.length <= descriptionLength"
                 class="text-formatted"
              >{{ incident.anonymous_description }}</p>
              <p v-if="!incident.anonymous_description" class="text-muted">
                {{ $t('system.missing_input') }}
              </p>
            </div>

            <div class="mt-3">
              <label qid="create-tp-link-label">
                {{ $t('maintenance.third_parties.create.links_label') }}
              </label>
              <br>
              <div v-if="incident.links">
                <p v-for="link in incident.links" >
                  <span class="float-right text-muted cursor-pointer"
                        @click="openDeleteLinkModal(link)"
                        qid="view-p-remove-link"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-p-link-item">
                    {{ link.name ? link.name : link.url }}
                  </a>
                </p>
              </div>
              <div v-if="showInput">
                <label class="mt-2">{{ $t('system.link') }}</label>
                <b-form-input
                  type="text"
                  aria-describedby="inputGroup"
                  v-model="inputLink"
                  :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                  qid="create-p-links"
                ></b-form-input>
                <label class="mt-2">{{ $t('table.name') }}</label>
                <b-form-input
                  type="text"
                  aria-describedby="inputGroup"
                  v-model="inputLinkName"
                  :placeholder="inputLink ? inputLink : $t('table.name')"
                  qid="create-p-links"
                ></b-form-input>
                <div class="text-right mt-2">
                  <span class="btn btn-success cursor-pointer mr-0"
                        id="inputGroup"
                        @click="handleEditLink"
                        qid="handle-link-save"
                  >
                    {{ $t('system.save') }}
                  </span>
                </div>
              </div>
              <span class="btn btn-link cursor-pointer"
                    @click="showInput = true"
                    qid="add-another-link"
              >
                <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
              </span>
            </div>

          </div>

        </div>
        <div>
          &nbsp;
        </div>
        <div v-if="incident.anonymous == 1">
          <span class="text-muted">
            {{ $t('maintenance.incidents.incident_categories.settings_tip') }}
          </span>
        </div>
      </div>
    </div>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import {config} from '@/config.js'
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';

  export default {
    name: 'IncidentSettings',
    data: function() {
      return {
        incident: {},
        descriptionLength: config.descriptionLength,
        showFullDescription: false,
        showDescriptionInput: false,
        anonymousDescription: '',
        showPurposeInput: false,
        incidentEditDescription: '',
        showForm: false,
        error: '',
        myGuides: [],
        myTasks: [],
        selectedAnonymous: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        showAttachments: false,
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        showInput: false,
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      submitForm: {},
      task: {}
    },
    components: {
      Avatar,
      UpdateSingleTaskModal,
      GuideButton,
      ConfirmRemoveAttachment
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.incident.id && this.$store.state.updatedObject.who_am_i == this.incident.who_am_i) {
              this.incident = this.$store.state.updatedObject
            }
          }
          this.loadContent()
        }
      },
      object: function (value) {
        this.incident = value

        if (this.showOnTask && !this.incident.description) {
          this.incidentEditDescription = ''
          this.showDescriptionInput = true;
        }

        if (this.showOnTask && this.incident.description) {
          this.showDescriptionInput = false;
        }
      },
      submitForm: function (value) {
        if (value) {
          if (this.showDescriptionInput) {
            this.formSubmit()
          }
        }
      }
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadContent()
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.incident.who_am_i,
              model_id: this.incident.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadContent();
      },
      handleEditLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("model_type", this.incident.who_am_i);
        formData.append("model_id", this.incident.id);

        piincHttp.post('links', formData).then(function() {
          self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'))
          self.loadContent()
          self.inputLink = ''
          self.inputLinkName = ''
          self.showInput = false
        }, function() {})
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'incident_categories.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Incident' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: language,
            type: 'Incident',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showFormFunction() {
        this.showForm = true;
        let self = this;
        this.selectedAnonymous = []
        if (this.incident.anonymous != null) {
          self.selectedAnonymous = _.find(self.radioOptions, function(item) {
            if(item.value === self.incident.anonymous){
              return item
            }
          });
        }
        if (this.incident.anonymous == null) {
          self.selectedAnonymous = self.radioOptions[1]
        }
      },
      formSubmit() {
        let self = this;
        piincHttp.put('incident-categories/' + this.incident.slug, {
          anonymous: this.selectedAnonymous.value,
          anonymous_description: this.anonymousDescription,
        }).then(function(response) {
          self.incident = response.data;
          self.showForm = false;
          self.$store.commit('storeUpdateContent', self.incident);
          self.$toastr('success', self.$t('maintenance.incidents.incident_categories.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      cancelForm() {
        this.showForm = false;
      },
      loadContent() {
        let self = this;
        piincHttp.get('incident-categories/' + this.incident.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.incident = response.data;
        }, function() {});
      }
    },
    created () {
      this.incident = this.object;

      if (this.showOnTask && !this.incident.description) {
        this.showDescriptionInput = true;
      }

      if (this.showOnTask) {
        this.loadContent()
      }

      this.loadGuides('update_settings');

    }
  }
</script>
